// @flow

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import account from './reducers/account';
import attachments from './reducers/attachments';
import builds from './reducers/builds';
import categories from './reducers/categories';
import categorySummary from './reducers/categorySummary';
import chats from '../simpleStore/reducers/chatsReducer';
import chatMessages from '../simpleStore/reducers/chatMessagesDictionaryReducer';
import couponFavorites from './reducers/couponFavorites';
import entities from './reducers/entities';
import icons from './reducers/icons';
import invoices from './reducers/invoices';
import fields from '../simpleStore/reducers/fieldsReducer';
import misc from './reducers/misc';
import myOfferings from './reducers/myOfferings';
import myWanteds from './reducers/myWanteds';
import notifications from './reducers/notifications';
import offerings from './reducers/offerings';
import offeringVideos from './reducers/offeringVideos';
import offeringReviews from './reducers/offeringReviews';
import paymentMethods from './reducers/paymentMethods';
import profile from './reducers/profile';
import purchases from './reducers/purchases';
import purchaseLands from './reducers/purchaseLands';
import purchaseSchema from './reducers/purchaseSchema';
import purchaseTickets from './reducers/purchaseTickets';
import questions from './reducers/questions';
import reviews from './reducers/reviews';
import reviewStars from './reducers/reviewStars';
import reviewDimensions from './reducers/reviewDimensions';
import sales from './reducers/sales';
import saleSchema from './reducers/saleSchema';
import saleLands from './reducers/saleLands';
import saleReviews from './reducers/saleReviews';
import saleTickets from './reducers/saleTickets';
import session from './reducers/session';
import supplyProposals from './reducers/supplyProposals';
import user from './reducers/user';
import waivers from './reducers/waivers';
import wanteds from './reducers/wanteds';
import profileTooltips from '../simpleStore/reducers/profileTooltipsReducer';
import unreadChatCount from '../simpleStore/reducers/unreadChatCountReducer';
import preferences from '../simpleStore/reducers/preferencesReducer';
import bookmarks from '../simpleStore/reducers/bookmarksReducer';
import browse from '../simpleStore/reducers/browseReducer';
import browseCards from '../simpleStore/reducers/browseCardsReducer';
import searchCards from '../simpleStore/reducers/searchCardsReducer';
import simpleReviewDimensions from '../simpleStore/reducers/reviewDimensionsReducer';
import websockets from '../simpleStore/reducers/websocketReducer';
import storefronts from '../simpleStore/reducers/storefrontsReducer';
import layout from '../simpleStore/reducers/layoutReducer';
import { LOG_OUT, LOG_IN } from './actionTypes';
import type { reduxAction } from './dataStoreTypes';

const appReducer = combineReducers({
  attachments,
  account,
  bookmarks,
  browse,
  browseCards,
  builds,
  categories,
  categorySummary,
  chats,
  chatMessages,
  couponFavorites,
  entities,
  icons,
  invoices,
  fields,
  layout,
  misc,
  myOfferings,
  myWanteds,
  notifications,
  offerings,
  offeringVideos,
  offeringReviews,
  paymentMethods,
  profile,
  purchases,
  purchaseLands,
  purchaseSchema,
  purchaseTickets,
  reviews,
  reviewStars,
  reviewDimensions,
  router: routerReducer,
  questions,
  sales,
  saleLands,
  saleReviews,
  saleSchema,
  saleTickets,
  searchCards,
  session,
  simpleReviewDimensions,
  supplyProposals,
  storefronts,
  user,
  waivers,
  websockets,
  wanteds,
  profileTooltips,
  unreadChatCount,
  preferences,
});

const rootReducer = (state: any, action: reduxAction) => {
  if (action.type === LOG_OUT || action.type === LOG_IN) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
